<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="top-candidate-row"
        transform="translate(-9, -6)"
        fill="#359685"
        fill-rule="nonzero"
      >
        <g
          id="open_in_new_24dp_FILL1_wght400_GRAD0_opsz24"
          transform="translate(9, 6)"
        >
          <path
            id="Shape"
            d="M1.33333333,12 C0.966666667,12 0.652777778,11.8694444 0.391666667,11.6083333 C0.130555556,11.3472222 0,11.0333333 0,10.6666667 L0,1.33333333 C0,0.966666667 0.130555556,0.652777778 0.391666667,0.391666667 C0.652777778,0.130555556 0.966666667,0 1.33333333,0 L6,0 L6,1.33333333 L1.33333333,1.33333333 L1.33333333,10.6666667 L10.6666667,10.6666667 L10.6666667,6 L12,6 L12,10.6666667 C12,11.0333333 11.8694444,11.3472222 11.6083333,11.6083333 C11.3472222,11.8694444 11.0333333,12 10.6666667,12 L1.33333333,12 Z M4.46666667,8.46666667 L3.53333333,7.53333333 L9.73333333,1.33333333 L7.33333333,1.33333333 L7.33333333,0 L12,0 L12,4.66666667 L10.6666667,4.66666667 L10.6666667,2.26666667 L4.46666667,8.46666667 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
